import React from "react";
import { Typography } from "@mui/material";

export default function InsertChecklist({ inserts = [], text = "" }) {
  return (
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      &nbsp;&nbsp;NB: Must include{" "}
      {inserts.map((ins, i) => {
        const found = text.includes(ins);

        return (
          <span key={ins} style={{ marginRight: 6 }}>
            <span
              style={{
                color: found ? "green" : "#922821",
                fontWeight: "bold",
                fontStyle: "italic",
              }}
            >
              {ins}
            </span>{" "}
            <span
              style={{
                color: found ? "green" : "#aaa",
                fontWeight: found ? "bold" : "normal",
              }}
            >
              {found ? "✔" : "○"}
            </span>
            {i < inserts.length - 1 && " "}
          </span>
        );
      })}
    </Typography>
  );
}
